import { Box, Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import appTheme from '../../theme/appTheme.json';
import BlockItem from './BlockItem';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogContent: {
      backgroundColor: appTheme.primaryBackgroundColor,
      color: appTheme.primaryTextColor,
      '@media print': {
        color: 'black',
        pageBreakBefore: 'always',
        padding: '20px 0px 0px 0px',
        backgroundColor: 'white',
      },
    },
    thePaper: {
      backgroundColor: appTheme.primaryBackgroundColor,
    },
  }),
);
export interface DisclaimerProps {
  padding?: string;
}
const Disclaimer = (props: DisclaimerProps) => {
  const { padding } = props;
  const classes = useStyles();
  return (
    <div className={classes.dialogContent} style={{ padding: padding ? padding : '40px 20px' }}>
      <Box fontSize="16px" letterSpacing="0.2px" fontWeight="bolder" top={'inherit'}>
        PROPRIETARY NOTICE
      </Box>
      <Box mt="16px" mb="32px" height="4px" width="80px" bgcolor="#ffffff" />
      <BlockItem
        header={<>Viasat Proprietary</>}
        content={
          <>
            This document contains commercial information or trade secrets of Viasat, Inc., which are confidential and
            exempt from disclosure to the public under the Freedom of Information Act, 5 U.S.C.552(b)(4), and unlawful
            disclosure thereof is a violation of the Trade Secrets Act, 18 U.S.C. 1905. Public disclosure of any such
            information or trade secrets shall not be made without the written permission of Viasat, Inc. © Viasat, Inc.
            2020 and the U.S. Department of State. This information may not be exported, re-exported, diverted,
            released, or disclosed to foreign nationals within or outside the United States without first complying with
            the export licensing requirements of the International Traffic in Arms Regulations (ITAR) and/or the Export
            Administration Regulations (EAR).{' '}
          </>
        }
      />
      <BlockItem
        header={<>Disclaimer - Forward Link (ground to terminal)</>}
        content={
          <>
            Depicted coverage and performance assumes production-graded terminal/platform operates in clear-sky
            conditions and at cruising speed. Actual coverage and performance are dependent on the individual platform
            (terminal equipment, installation, and configurations), terrestrial network configurations, weather
            conditions, satellite beam capacity (over-the-air satellite link rate for the individual terminal at the
            current location assumes 100% utilization of the forward link capacity), subscription level, network
            contention, platform altitude, and the degree of blockage due to flight dynamics but they are not all
            inclusive.
          </>
        }
      />
      <BlockItem
        header={<>Disclaimer - Burst Return Link (terminal to ground)</>}
        content={
          <>
            Depicted coverage and performance assumes production-graded terminal/platform operates in clear-sky
            conditions and at cruising speed. Actual coverage and performance are dependent on the individual platform
            (terminal equipment, installation, and configurations), terrestrial network configurations, weather
            conditions, satellite beam capacity (aggregated over-the-air satellite link rate of all terminals at various
            locations assumes 100% utilization of the return link capacity), subscription level, network congestion,
            platform altitude, and the degree of blockage due to flight dynamics but they are not all inclusive.
          </>
        }
      />
      <BlockItem
        header={<>Disclaimer - Continuous Return Link (terminal to ground)</>}
        content={
          <>
            Depicted coverage and performance assumes production-graded terminal/platform operates in clear-sky
            conditions and at cruising speed. Actual coverage and performance are dependent on the individual platform
            (terminal equipment, installation, and configurations), terrestrial network configurations, weather
            conditions, subscription level, platform altitude, and the degree of blockage due to flight dynamics but
            they are not all inclusive.
          </>
        }
      />
    </div>
  );
};
export default Disclaimer;
